var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLbs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3917 39.9055C37.8208 40.6913 39.5417 40.6913 40.9708 39.9055L54.9708 32.0481C56.4292 31.2332 57.3625 29.6618 57.3625 28.003V12.4918C57.3625 10.804 56.4583 9.26157 54.9708 8.44673L40.9708 0.589307C39.5417 -0.196436 37.8208 -0.196436 36.3917 0.589307L22.3917 8.44673C20.9333 9.26157 20 10.8331 20 12.4918V28.003C20 29.6909 20.9042 31.2332 22.3917 32.0481L36.3917 39.9055Z",
    fill: "#0C85C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3917 72.9055C59.8208 73.6913 61.5417 73.6913 62.9708 72.9055L76.9708 65.0481C78.4292 64.2332 79.3625 62.6618 79.3625 61.003V45.4918C79.3625 43.804 78.4583 42.2616 76.9708 41.4467L62.9708 33.5893C61.5417 32.8036 59.8208 32.8036 58.3917 33.5893L44.3917 41.4467C42.9333 42.2616 42 43.8331 42 45.4918V61.003C42 62.6909 42.9042 64.2332 44.3917 65.0481L58.3917 72.9055Z",
    fill: "#0C85C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3917 73.9055C17.8208 74.6913 19.5417 74.6913 20.9708 73.9055L34.9708 66.0481C36.4292 65.2332 37.3625 63.6618 37.3625 62.003V46.4918C37.3625 44.804 36.4583 43.2616 34.9708 42.4467L20.9708 34.5893C19.5417 33.8036 17.8208 33.8036 16.3917 34.5893L2.39168 42.4467C0.933345 43.2616 0 44.8331 0 46.4918V62.003C0 63.6909 0.904178 65.2332 2.39168 66.0481L16.3917 73.9055Z",
    fill: "#0C85C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbs);
export default __webpack_public_path__ + "static/media/LBS.12156c5ad80881f2a25d17c3d2a42b92.svg";
export { ForwardRef as ReactComponent };